import _ from "lodash";
import moment from "moment";

import { webTransferTimeFormat } from "../config";
import { FLIGHT_TYPE_CF, FLIGHT_TYPE_OW } from "../constants";
import { encodeSearchId } from "./searchId";

/**
 * searchId для повторного поиска «как в заказе».
 * Сначала — параметры поиска из стора (если клиент пришёл через сайт), иначе восстанавливаем из данных заказа:
 * города и даты из сегментов, класс из service_class, состав пассажиров из passenger_data.
 * Возвращает null, если собрать не из чего.
 */
export const getSearchIdForOrder = (orderData, searchParams) => {
  if (searchParams?.routes?.[0]?.from?.code && searchParams?.routes?.[0]?.date) {
    try {
      return encodeSearchId(searchParams.flightType, searchParams.cabin, searchParams.routes, searchParams.passengers);
    } catch (e) {
      // стор мог остаться от другого поиска в неполном виде — идём по данным заказа
    }
  }

  const routes = _.map(orderData?.routes, route => {
    const first = _.first(route?.segments);
    const last = _.last(route?.segments);
    if (!first || !last) return null;

    return {
      from: { code: first.departure?.city || first.departure?.airport },
      to: { code: last.arrival?.city || last.arrival?.airport },
      date: moment(first.departure?.time, webTransferTimeFormat),
    };
  }).filter(route => route && route.from.code && route.to.code && route.date.isValid());

  if (routes.length === 0) return null;

  const passengers = { adt: 0, chd: 0, ins: 0, inf: 0 };
  _.forEach(orderData?.passenger_data, passenger => {
    if (passengers[passenger?.type] !== undefined) passengers[passenger.type] += 1;
  });
  if (passengers.adt === 0) passengers.adt = 1;

  const serviceClass = _.first(orderData?.routes)?.segments?.[0]?.service_class;
  const className = _.toLower(_.isString(serviceClass) ? serviceClass : serviceClass?.name || "");
  const cabin = ["economy", "business", "first"].includes(className) ? className : "all";

  // CF с двумя обратными маршрутами encodeSearchId сам сведёт к RT
  const flightType = routes.length === 1 ? FLIGHT_TYPE_OW : FLIGHT_TYPE_CF;

  try {
    return encodeSearchId(flightType, cabin, routes, passengers);
  } catch (e) {
    return null;
  }
};
